import React, { useEffect, useState } from 'react';
import BoardContext from './context'; 
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import List from '../List';

import { Container } from './styles';
import api from '../../services/api';
import loading from '../../images/loading.gif';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthContext';

export default function Board({userId}) {
  const { user } = useAuth()

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [lists, setLists]= useState([])

  useEffect(() => {
    loadingGrid()
  }, [])

  async function loadingGrid() {
    const listsC = {
     "Oportunidade":  {
        name: "Oportunidade",
        leads: [],
      },
     "Abordagem":  {
        name: "Abordagem",
        leads: [],
      },
      "Atendimento":  {
        name: "Atendimento",
        leads: [],
      },
      "Qualificação":  {
        name: "Qualificação",
        leads: [],
      },
      "Proposta Enviada":  {
        name: "Proposta Enviada",
        leads: [],
      },
      "Negociação":  {
        name: "Negociação",
        leads: [],
      },
      "Cliente Perdido":  {
        name: "Cliente Perdido",
        leads: [],
      },
      "Cliente Fechado":  {
        name: "Cliente Fechado",
        leads: [],
      }
    }
    await api.get(userId ? `/leads/${userId}` : "/leads/me").then((response) => {
      const leads = response.data
      leads.map((item)=>{
        if(listsC[item.status]){
          listsC[item.status].leads.push(item)
        }
      })
    }).catch(({ response }) => {
      if (response) {
        if (response.data) {
          if (response.data.message) {
            toast.warn(response.data.message)
            if(response.data.message == "Você não faz parte desse quadro"){
              navigate("/")
            }
          } else {
            toast.error("Erro Interno. verifique sua conexão e tente novamente")
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente")
        }
      } else {
        toast.error("Erro Interno. verifique sua conexão e tente novamente")
      }
    })
    setLists(Object.values(listsC))
    setIsLoading(false)
  }

  async function move(fromList, toList, name) {
    const listsC = [...lists]
    if(toList >= 4 || fromList >= 4){
      toast.error('Não é possivel mover o lead mais');
      return ""
    }
    
    const from = listsC[fromList].leads.map(e => e.id).indexOf(name)
    await api.put(`/lead/status/${name}`, {
      status: lists[toList].name,
      label: `movido de ${lists[fromList].name} para ${lists[toList].name} por ${userId ? "administrado" : user.name}`
    }).then(() => {
      listsC[fromList].leads[from].status = lists[toList].name
      listsC[fromList].leads[from].historical.push({
        create_at: new Date(),
        name: `movido de ${lists[fromList].name} para ${lists[toList].name} por ${userId ? "administrado" : user.name}`
      })
      toast.success(`${lists[fromList].leads[from].name} movido com sucesso para ${lists[toList].name}`);
      listsC[toList].leads.unshift({ ...listsC[fromList].leads[from] })
      listsC[fromList].leads = listsC[fromList].leads.filter((e, i) => { return i != from })
      setLists(listsC)
    }).catch((e) => {
      toast.error('Houve um erro ao mover lead');
    })
  }

  function edit(listsC) {
    setLists([...listsC])
  }

  return (
    <BoardContext.Provider value={{ lists, move, edit }}>
      <Container>
        <div className='header'>
          <h4>CRM Guruseg</h4>
        </div>
        {
          isLoading && (
            <div className='center'>
              <img src={loading} style={{ background: "transparent", height: 50, width: 50, margin: "0 40px" }} />
            </div>
          )
        }
        {lists.map((list, index) =>
          <List key={list.name} index={index} data={list} lists={lists} userId={userId} disabled={index >= 4 && index < 5} />
        )}
      </Container>
    </BoardContext.Provider>
  );
}
